module.exports = __webpack_public_path__ + "0ce96df0c3b5c7e7370f4712a9eca0c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/temporal-weave-video-poster.jpg
// module id = 553
// module chunks = 0